import React, { FC } from 'react';

import { Tooltip } from '@mantine/core';

import { BadgePill } from 'components/badges/BadgePill';
import { DCIDE } from 'components/logo/DCIDE';

import { useComponentContext } from '../../hooks/use-component-context';
import { BadgeGroup } from './BadgeGroup';

const PplReady: FC = () => {
    const { component } = useComponentContext();

    const hasAddressMaps = !!component.controller?.addressmaps?.length;

    if (!hasAddressMaps) {
        return null;
    }

    return (
        <BadgeGroup label="Integration">
            <Tooltip
                label={
                    <>
                        This device includes validated address maps, enabling
                        <br />
                        plug-and-play integration with the DCIDE Controller.
                    </>
                }
            >
                <BadgePill fw={600}>
                    <DCIDE height={11} />
                    Controller Ready
                </BadgePill>
            </Tooltip>
        </BadgeGroup>
    );
};

export { PplReady };
